import React, { useEffect, useState, useContext, useMemo } from 'react'
import axios from 'axios'
import Cookies from 'js-cookie'
import { AuthContext } from '../AuthContext'
import Papa from 'papaparse'
import ContactsModal from './ContactsModal'
import { Container, ProgressBar, Modal, Button, Spinner } from 'react-bootstrap'
import {
  TASK_PRESETS,
  REPEAT_OPTIONS,
  EXERCISE_OPTIONS,
  LINK_TYPE_TASKS,
} from '../../constants/taskConstants'
import {
  parseDateTime,
  get100YearsLater,
  parsePhones,
  processPhoneNumber,
  isValidTaiwanPhone,
  getRepeatValue,
  getRepeatOptionFromValue,
  getStatusText,
} from '../../utils/taskUtils'

const PushTask = ({
  editMode = false, // 是否為編輯模式
  taskId = null, // 編輯的任務資料
  onCancel = null, // 取消回調
  onUpdate = null, // 更新回調
}) => {
  const { baseUrl, currentUser, extendCookie, setLoginShow } =
    useContext(AuthContext)
  const sessionFromCookie = Cookies.get('session')
  const { session = '' } = sessionFromCookie
    ? JSON.parse(sessionFromCookie)
    : {}

  // 表單狀態，根據編輯模式載入資料
  const [formData, setFormData] = useState({
    taskType: '',
    remark: '',
    taskTitle: '',
    taskDescription: '',
    taskLink: '',
    targetValue: '',
    haCoins: '',
    isTopTask: null,
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
    noEndTime: false,
    repeatOption: null,
    recipients: { type: '', phones: [] },
    exercise_type: '',
    excludeMemberList: [],
  })

  // 其他狀態
  const [selectedTaskPreset, setSelectedTaskPreset] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [message, setMessage] = useState({ type: '', content: '' })
  const [errors, setErrors] = useState({})
  // 推送對象，根據編輯模式載入資料
  const [recipientMode, setRecipientMode] = useState(() => {
    if (editMode && taskId?.recipients?.type) {
      return taskId.recipients.type
    }
    return ''
  }) // 'all' | 'contacts' | 'csv' | 'manual'
  const [manualPhones, setManualPhones] = useState(() => {
    if (editMode && taskId?.recipients?.type === 'manual') {
      return taskId.recipients.phones.join(', ')
    }
    return ''
  })
  const [csvPhones, setCsvPhones] = useState(() => {
    if (editMode && taskId?.recipients?.type === 'csv') {
      return taskId.recipients.phones
    }
    return []
  })
  const [csvName, setCsvName] = useState('')
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  // 成功 Modal 狀態
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [successType, setSuccessType] = useState('') // 'save' 或 'draft'

  // 聯絡人 modal 狀態管理
  const [showContactsModal, setShowContactsModal] = useState(false)
  const [memberGroups, setMemberGroups] = useState([])
  const [tags, setTags] = useState([])
  const [selectedGroups, setSelectedGroups] = useState([])
  const [selectedTags, setSelectedTags] = useState([])
  const [activeTab, setActiveTab] = useState('contacts') // 'contacts' 或 'tags'
  const [selectedContacts, setSelectedContacts] = useState([]) // 已選擇的聯絡人/標籤
  const [searchTerm, setSearchTerm] = useState('') // 搜尋關鍵字
  const [isLoadingGroups, setIsLoadingGroups] = useState(false)
  const [isLoadingTags, setIsLoadingTags] = useState(false)

  // 編輯模式 taskdata 狀態
  const [isLoadingTask, setIsLoadingTask] = useState(false)
  const [taskData, setTaskData] = useState(null)

  // 查詢特定會員
  const [memberSearchPhone, setMemberSearchPhone] = useState('')
  const [searchedMember, setSearchedMember] = useState(null)
  const [isSearchingMember, setIsSearchingMember] = useState(false)
  const [memberSearchError, setMemberSearchError] = useState('')
  // 刪除特定聯絡人
  const [showDeletePhoneModal, setShowDeletePhoneModal] = useState(false)

  // fetch 任務詳細資料的函數
  const fetchTaskDetail = async (taskId) => {
    setIsLoadingTask(true)
    try {
      if (!session) {
        alert('登入已逾時，請重新登入')
        setLoginShow(true)
        throw new Error('Session not found')
      }

      const response = await axios.post(
        `${baseUrl}/api/backend/mission/get`,
        { mission_id: taskId },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
            session: session,
          },
        }
      )

      console.log('任務詳情 API 回應:', response.data)

      if (response.data) {
        // 判斷任務狀態的邏輯
        const getTaskStatus = (mission) => {
          // 1. 若已刪除則以已刪除為優先
          if (mission.is_deleted === 1) {
            return 'deleted'
          }

          // 2. 若同時遇到暫存中且已結束(以上架時間判斷)則以暫存中為優先
          if (mission.status === 0) {
            // 未上架(暫存)
            return 'draft'
          }

          // 3. 判斷已上架的任務是否已結束
          if (mission.status === 1) {
            // 已上架
            // 檢查是否已過結束時間
            if (mission.end_time) {
              const endTime = new Date(mission.end_time)
              const now = new Date()
              if (now > endTime) {
                return 'ended' // 已結束
              }
            }
            return 'active' // 上架中
          }

          // 預設返回暫存中
          return 'draft'
        }
        const mission = response.data

        // 處理 member_group_list
        let allPhones = []
        if (mission.member_group_list && mission.member_group_list.length > 0) {
          try {
            // 對每個群組 ID 發送 API 請求獲取詳細資訊
            const groupDetailPromises = mission.member_group_list.map(
              async (group) => {
                try {
                  const groupResponse = await axios.post(
                    `${baseUrl}/api/backend/memberGroup/get`,
                    { member_group_id: group.member_group_id.toString() },
                    {
                      headers: {
                        'Content-Type': 'application/json',
                        Accept: '*/*',
                        session: session,
                      },
                    }
                  )

                  console.log(
                    `群組 ${group.member_group_id} 詳情 API 回應:`,
                    groupResponse.data
                  )

                  if (groupResponse.data && groupResponse.data.member_list) {
                    return groupResponse.data.member_list
                  }
                  return []
                } catch (error) {
                  console.error(
                    `獲取群組 ${group.member_group_id} 詳情失敗:`,
                    error
                  )
                  return []
                }
              }
            )

            // 等待所有群組詳情請求完成
            const groupPhoneLists = await Promise.all(groupDetailPromises)

            // 合併所有電話號碼並去重複
            const flatPhones = groupPhoneLists.flat()
            allPhones = [...new Set(flatPhones)] // 使用 Set 去重複

            console.log('從群組獲取的所有電話號碼（已去重）:', allPhones)
          } catch (error) {
            console.error('處理群組電話號碼時發生錯誤:', error)
          }
        }

        const taskDetail = {
          id: mission.mission_id,
          taskType: mission.type,
          taskTitle: mission.name,
          taskComment: mission.comment,
          taskDescription: mission.description,
          taskLink: mission.link || '',
          targetValue: mission.target_value || 0,
          haCoins: mission.ha_coin || 0,
          isTopTask: mission.is_top === 1,
          startTime: mission.start_time,
          endTime: mission.end_time,
          repeatOption: mission.renew,
          exercise_type: mission.exercise_type,
          status: getTaskStatus(mission),
          recipients: {
            sendType: mission.send_type,
            type:
              mission.send_type === 0
                ? 'all'
                : mission.send_type === 1
                  ? 'contacts'
                  : 'members',
            // 修改：合併原有電話號碼和從群組獲取的電話號碼，並排除 exclude_member_list
            phones: (() => {
              // 合併原有電話號碼和從群組獲取的電話號碼
              const allPhoneNumbers = [
                ...new Set([...(mission.member_list || []), ...allPhones]),
              ]

              // 排除 exclude_member_list 中的電話號碼
              const excludeList = mission.exclude_member_list || []
              const filteredPhones = allPhoneNumbers.filter(
                (phone) => !excludeList.includes(phone)
              )

              console.log('原始電話號碼:', allPhoneNumbers)
              console.log('排除清單:', excludeList)
              console.log('過濾後電話號碼:', filteredPhones)

              return filteredPhones
            })(),
            memberGroups: mission.member_group_list || [],
          },
          excludeMemberList: mission.exclude_member_list || [],
        }

        setTaskData(taskDetail)

        if (
          taskDetail.recipients.type === 'contacts' &&
          taskDetail.recipients.memberGroups
        ) {
          const groupIds = taskDetail.recipients.memberGroups.map(
            (group) => group.member_group_id
          )
          setSelectedGroups(groupIds)
          console.log('設定編輯模式的 selectedGroups:', groupIds)
        }

        // 設置表單資料
        const startDateTime = parseDateTime(taskDetail.startTime)
        const endDateTime = parseDateTime(taskDetail.endTime)

        const repeatOption = getRepeatOptionFromValue(taskDetail.repeatOption)

        setFormData({
          taskType: taskDetail.taskType.toString(),
          remark: taskDetail.taskComment || '',
          taskTitle: taskDetail.taskTitle,
          taskDescription: taskDetail.taskDescription || '',
          taskLink: taskDetail.taskLink || '',
          targetValue: taskDetail.targetValue.toString(),
          haCoins: taskDetail.haCoins.toString(),
          isTopTask: taskDetail.isTopTask,
          startDate: startDateTime.date,
          startTime: startDateTime.time,
          endDate: endDateTime.date,
          endTime: endDateTime.time,
          noEndTime:
            endDateTime.isNoEndTime || taskDetail.endTime?.includes('2125'),
          repeatOption: repeatOption,
          recipients: taskDetail.recipients,
          exercise_type:
            taskDetail.exercise_type !== null &&
            taskDetail.exercise_type !== undefined
              ? taskDetail.exercise_type.toString()
              : '',
          excludeMemberList: taskDetail.excludeMemberList || [],
        })

        // 如果是運動類型且有運動項目，需要設置 exerciseType
        // if (taskDetail.taskType === 6 && taskDetail.exercise_type !== null) {
        //   setFormData((prev) => ({
        //     ...prev,
        //     exerciseType: taskDetail.exercise_type.toString(),
        //   }))
        // }

        extendCookie()
      } else if (response.data?.error?.code === '50004') {
        alert('登入已逾時，請重新登入')
        setLoginShow(true)
      } else {
        throw new Error('未收到預期的資料格式')
      }
    } catch (error) {
      console.error('獲取任務詳情失敗:', error)

      alert('獲取任務資料失敗')
      if (onCancel) onCancel()
    } finally {
      setIsLoadingTask(false)
    }
  }

  // 在編輯模式下自動 fetch 任務資料
  useEffect(() => {
    if (editMode && taskId) {
      fetchTaskDetail(taskId)
    }
  }, [editMode, taskId])

  // message 自動清除的 useEffect
  useEffect(() => {
    if (message.content) {
      const timer = setTimeout(() => {
        setMessage({ type: '', content: '' })
      }, 3000) // 3秒後清除

      return () => clearTimeout(timer)
    }
  }, [message])

  // 滾動到第一個錯誤的函數
  const scrollToFirstError = (errors) => {
    const firstErrorKey = Object.keys(errors)[0]
    if (!firstErrorKey) return
    console.log('第一個錯誤欄位:', firstErrorKey)
    if (firstErrorKey) {
      // 嘗試找到對應的表單元素

      const elementSelectors = {
        taskType: 'select[value]',
        exercise_type: 'select[name="exercise_type"]',
        remark: 'input[placeholder*="建議輸入專案名稱或對象"]',
        taskTitle: 'input[placeholder*="任務標題"]',
        taskDescription: 'textarea[placeholder*="任務內文"]',
        taskLink: 'input[placeholder*="任務導向"]',
        targetValue: 'input[placeholder*="完成目標"]',
        haCoins: 'input[placeholder*="獎勵 HA 幣"]',
        isTopTask: 'input[name="isTopTask"]',
        startDate: 'input[type="date"]',
        startTime: 'input[type="time"]',
        endDate: 'input[type="date"]:not(:disabled)',
        endTime: 'input[type="time"]:not(:disabled)',
        repeatOption: 'input[name="repeatOption"]',
        recipientMode: 'input[name="recipientMode"]',
        manualPhones: 'textarea[placeholder*="手機號碼"]',
      }

      const selector = elementSelectors[firstErrorKey]
      if (selector) {
        const element = document.querySelector(selector)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
          // 如果是輸入框，也可以讓它獲得焦點
          if (
            element.focus &&
            (element.tagName === 'INPUT' ||
              element.tagName === 'TEXTAREA' ||
              element.tagName === 'SELECT')
          ) {
            setTimeout(() => element.focus(), 300)
          }
        }
      }
    }
  }

  // 處理任務類型選擇
  const handleTaskTypeChange = (e) => {
    const taskType = e.target.value

    // 編輯模式下不自動載入預設值
    if (editMode) {
      setFormData((prev) => ({
        ...prev,
        taskType,
      }))
      setErrors({})
      return
    }

    // 獲取預設任務資料
    const taskPreset = TASK_PRESETS[taskType]?.defaultTask

    if (taskPreset) {
      setSelectedTaskPreset(taskPreset)
      setFormData((prev) => ({
        ...prev,
        taskType,
        taskTitle: taskPreset.name,
        taskDescription: taskPreset.description,
        taskLink: taskPreset.link,
        targetValue: taskPreset.targetValue.toString(),
        haCoins: taskPreset.reward.toString(),
      }))
    } else {
      // 如果沒有預設資料，清空表單
      setSelectedTaskPreset(null)
      setFormData((prev) => ({
        ...prev,
        taskType,
        taskTitle: '',
        taskDescription: '',
        taskLink: '',
        targetValue: '',
        haCoins: '',
      }))
    }

    setErrors({})
  }

  // 處理無結束時間勾選
  const handleNoEndTimeChange = (e) => {
    const isChecked = e.target.checked

    if (isChecked) {
      // 勾選無結束時間：使用固定的 2125年1月1日 00:00:00
      const future = get100YearsLater() // 不傳參數，使用預設值

      setFormData((prev) => ({
        ...prev,
        noEndTime: isChecked,
        endDate: future.date,
        endTime: future.time,
      }))
    } else {
      // 取消勾選：清空結束時間，讓用戶重新填寫
      setFormData((prev) => ({
        ...prev,
        noEndTime: isChecked,
        endDate: '',
        endTime: '',
      }))
    }

    // 清除相關錯誤
    if (isChecked) {
      setErrors((prev) => ({
        ...prev,
        endDate: '',
        endTime: '',
      }))
    }
  }

  // 處理 CSV 上傳（只取到的第一個檔）
  const handleCsvUpload = (e) => {
    const f = e.target.files?.[0]
    if (!f) return
    setCsvName(f.name)

    // 使用 Papa.parse 解析 CSV，參考 contactsettings.js
    Papa.parse(f, {
      header: false, // 不使用表頭，直接讀取原始資料
      skipEmptyLines: true, // 跳過空行
      complete: (results) => {
        try {
          const phoneNumbers = []

          // 遍歷所有行和列，提取所有可能的電話號碼
          results.data.forEach((row) => {
            row.forEach((cell) => {
              if (cell && typeof cell === 'string') {
                const cellStr = String(cell).trim()

                // 處理可能的電話號碼格式
                const processedPhone = processPhoneNumber(cellStr)

                // 驗證處理後的電話號碼
                if (isValidTaiwanPhone(processedPhone)) {
                  phoneNumbers.push(processedPhone)
                }
              }
            })
          })

          // 去除重複的電話號碼
          const uniquePhones = [...new Set(phoneNumbers)]

          setCsvPhones(uniquePhones)

          // 清掉錯誤
          setErrors((prev) => ({
            ...prev,
            recipientMode: '',
            manualPhones: '',
          }))
        } catch (error) {
          console.error('CSV 解析失敗：', error.message)
          setCsvPhones([])
          setErrors((prev) => ({
            ...prev,
            recipientMode: 'CSV 解析失敗：' + error.message,
          }))
        }
      },
      error: (error) => {
        console.error('CSV 讀取失敗：', error.message)
        setCsvPhones([])
        setErrors((prev) => ({
          ...prev,
          recipientMode: 'CSV 讀取失敗：' + error.message,
        }))
      },
    })
  }

  // 處理表單輸入變更
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }))

    // 清除相關錯誤
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: '',
      }))
    }
  }

  // 驗證表單
  const validateForm = () => {
    const newErrors = {}
    console.log('驗證表單', formData)
    console.log('selectedGroups', selectedGroups)

    if (!formData.taskType) {
      newErrors.taskType = '請選擇任務類型'
    }

    // 運動類型特殊驗證
    if (formData.taskType === '6' && !formData.exercise_type) {
      newErrors.exercise_type = '請選擇運動項目'
    }

    if (!formData.remark.trim()) {
      newErrors.remark = '請輸入備註'
    }

    if (!formData.taskTitle.trim()) {
      newErrors.taskTitle = '請輸入任務標題'
    }

    if (!formData.taskDescription.trim()) {
      newErrors.taskDescription = '請輸入任務內文'
    }

    if (!formData.taskLink.trim()) {
      // 檢查是否為連結型任務（需要自定義連結的任務）
      const isLinkTypeTask = LINK_TYPE_TASKS.includes(
        parseInt(formData.taskType)
      )

      if (isLinkTypeTask) {
        newErrors.taskLink = '請輸入任務導向網頁連結'
      } else {
        // 🔧 對於非連結型任務（如血糖），如果是空的就自動設為 "App 頁面"
        // 但不要在這裡直接修改 formData，而是在提交時處理
      }
    }

    if (!formData.targetValue.trim()) {
      newErrors.targetValue = '請輸入完成目標'
    }

    if (!formData.haCoins.trim()) {
      newErrors.haCoins = '請輸入獎勵 HA 幣'
    }

    if (formData.isTopTask === null) {
      newErrors.isTopTask = '請選擇是否置頂'
    }

    // 時間驗證
    if (!formData.startDate) {
      newErrors.startDate = '請選擇開始日期'
    }

    if (!formData.startTime) {
      newErrors.startTime = '請選擇開始時間'
    }

    if (!formData.noEndTime && !formData.endDate) {
      newErrors.endDate = '請選擇結束日期'
    }

    if (!formData.noEndTime && !formData.endTime) {
      newErrors.endTime = '請選擇結束時間'
    }

    // 驗證結束時間是否晚於開始時間
    if (
      formData.startDate &&
      formData.startTime &&
      formData.endDate &&
      formData.endTime &&
      !formData.noEndTime
    ) {
      const startDateTime = new Date(
        `${formData.startDate}T${formData.startTime}`
      )
      const endDateTime = new Date(`${formData.endDate}T${formData.endTime}`)

      if (endDateTime <= startDateTime) {
        newErrors.endDate = '結束時間必須晚於開始時間'
        newErrors.endTime = '結束時間必須晚於開始時間'
      }
    }

    if (!formData.repeatOption) {
      newErrors.repeatOption = '請選擇重複選項'
    }

    // 推送對象
    if (!editMode) {
      const r = formData.recipients || {}
      if (!r.type) {
        newErrors.recipientMode = '請選擇推送對象來源'
      } else if (
        r.type === 'contacts' &&
        (!selectedGroups || selectedGroups.length === 0)
      ) {
        // 防呆1: 勾選已建立聯絡人(send_type=1)檢查selectedGroups是否長度>0
        newErrors.recipientMode = '請選擇至少一個聯絡人群組'
      } else if (r.type === 'members' && (!r.phones || r.phones.length === 0)) {
        // 防呆2: 勾選會員手機清單模式(send_type=2)檢查formData.recipients.phones是否長度>0
        newErrors.manualPhones = '請確認手機號碼清單不為空'
      }

      // 防呆2: 勾選上傳手機號碼或手動輸入時(send_type=2)檢查formData.recipients.phones是否長度>0
      if (
        (r.type === 'manual' || r.type === 'csv') &&
        r.phones &&
        r.phones.length === 0
      ) {
        if (r.type === 'manual') {
          newErrors.manualPhones = '請輸入至少一組有效手機號碼'
        } else {
          newErrors.recipientMode = '請確認 CSV 檔案中包含有效的手機號碼'
        }
      }
    } else {
      // 編輯模式的驗證
      if (formData.recipients.type === 'contacts') {
        const hasGroups =
          (formData.recipients.memberGroups &&
            formData.recipients.memberGroups.length > 0) ||
          (selectedGroups && selectedGroups.length > 0)
        if (!hasGroups) {
          newErrors.recipientMode = '請選擇至少一個聯絡人群組'
        }
      }
    }

    setErrors(newErrors)
    // 返回驗證結果
    const hasErrors = Object.keys(newErrors).length > 0
    if (hasErrors) {
      setTimeout(() => scrollToFirstError(newErrors), 100)
    }

    return !hasErrors // 返回 true 表示驗證通過，false 表示有錯誤
  }

  // 組合推送對象 recipientsPayload（可依你後端格式調整）
  const buildRecipientsPayload = () => {
    const base = { type: recipientMode, phones: [] }
    if (recipientMode === 'manual') {
      base.phones = parsePhones(manualPhones) // 確保是陣列
    }
    if (recipientMode === 'csv') {
      base.phones = csvPhones || [] // 確保是陣列
    }
    return base
  }

  // 同步 UI 狀態 -> formData.recipients（避免無限迴圈做淺比較）
  useEffect(() => {
    const next = buildRecipientsPayload()
    setFormData((prev) => {
      const same =
        prev?.recipients?.type === next.type &&
        Array.isArray(prev?.recipients?.phones) &&
        prev.recipients.phones.length === next.phones.length &&
        prev.recipients.phones.every((v, i) => v === next.phones[i])
      return same ? prev : { ...prev, recipients: next }
    })
  }, [recipientMode, manualPhones, csvPhones])

  // 處理儲存的函數
  const handleSave = async (e) => {
    e?.preventDefault?.()

    if (!validateForm()) return

    // 如果原本是草稿狀態就存成草稿，否則就存成正式狀態
    const isDraft = taskData?.status === 'draft'
    await handleSubmit(isDraft)
  }

  // 暫存表單
  const handleSaveDraft = async (e) => {
    e?.preventDefault?.()

    if (!validateForm()) return

    await handleSubmit(true) // 傳入 true 表示暫存
  }

  // 顯示確認 modal
  const handleShowConfirm = (e) => {
    e.preventDefault()

    // 執行驗證並根據結果決定是否顯示確認 modal
    const isValid = validateForm()

    if (isValid) {
      // 驗證通過才顯示確認 modal
      setShowConfirmModal(true)
    }
    // 如果驗證失敗，validateForm 內部已經處理滾動到錯誤位置
  }

  // 真正的送出函數
  const handleConfirmSubmit = async () => {
    await handleSubmit(false) // 傳入 false 表示正式提交
  }

  const handleSubmit = async (isDraft = false) => {
    setIsSubmitting(true)
    setMessage({ type: '', content: '' })

    try {
      if (!session) {
        setMessage({
          type: 'error',
          content: '請先登入',
        })
        setLoginShow(true)
        return
      }

      // 處理結束時間邏輯
      let endTime
      if (formData.noEndTime) {
        // 如果勾選無結束時間，檢查是否有開始時間來決定使用哪種方式
        if (formData.startDate && formData.startTime) {
          // 有開始時間：計算100年後
          const future = get100YearsLater(
            formData.startDate,
            formData.startTime
          )
          endTime = future.fullDateTime
        } else {
          // 沒有開始時間：使用固定的 2125年1月1日
          endTime = '2125-01-01 00:00:00'
        }
      } else {
        // 沒勾選無結束時間：使用用戶設定的結束時間
        endTime = `${formData.endDate} ${formData.endTime || '23:59'}:00`
      }

      // 根據 recipients.type 決定 send_type 和對應的資料
      let sendType = 0
      let memberGroupList = []
      let memberList = []
      console.log('formData', formData)
      console.log('selectedGroups', selectedGroups)

      if (formData.recipients && formData.recipients.type !== 'all') {
        if (formData.recipients.type === 'contacts') {
          // 原本的聯絡人群組模式
          sendType = 1
          // 編輯模式：優先使用 formData.recipients.memberGroups
          // 非編輯模式：使用 selectedGroups
          if (
            editMode &&
            formData.recipients.memberGroups &&
            formData.recipients.memberGroups.length > 0
          ) {
            memberGroupList = formData.recipients.memberGroups.map(
              (group) => group.member_group_id
            )
          } else {
            memberGroupList = selectedGroups || []
          }
          memberList = [] // 群組模式不需要直接的 member_list
        } else if (formData.recipients.type === 'members') {
          // 會員手機清單模式 (包含從群組刪除電話號碼後轉換的情況)
          sendType = 2
          memberGroupList = [] // 手機清單模式不使用群組
          memberList = formData.recipients.phones || []

          console.log('使用會員手機清單模式 (send_type=2)')
          console.log('電話號碼列表:', memberList)
        }
      }

      // 處理表單資料並轉換為 API 格式
      const payload = {
        name: formData.taskTitle,
        description: formData.taskDescription,
        comment: formData.remark,
        status: isDraft ? 0 : 1, // 0=暫存，1=已上架
        target_value: parseInt(formData.targetValue) || 0,
        ha_coin: parseInt(formData.haCoins) || 0,
        is_top: formData.isTopTask ? 1 : 0,
        start_time: `${formData.startDate} ${formData.startTime || '00:00'}:00`,
        end_time: endTime,
        type: parseInt(formData.taskType),
        exercise_type:
          formData.taskType === '6'
            ? parseInt(formData.exercise_type) || 0
            : null,
        link: formData.taskLink || '',
        renew: getRepeatValue(formData.repeatOption),
        send_type: sendType,
        member_group_list: memberGroupList,
        member_list: memberList,
        exclude_member_list: formData.excludeMemberList || [],
      }

      // 如果是編輯模式，需要加上 mission_id
      if (editMode && taskId) {
        payload.mission_id = taskId
      }

      console.log('提交的 payload:', payload)

      const apiEndpoint = editMode
        ? '/api/backend/mission/update' // 編輯模式使用 update API
        : '/api/backend/mission/add' // 新增模式使用 add API

      // 呼叫新增任務 API
      const response = await axios.post(`${baseUrl}${apiEndpoint}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
          session: session,
        },
      })

      const apiDescription = editMode ? '更新任務' : '新增任務'
      console.log(`${apiDescription} API 回應:`, response.data)

      // 根據 API 回應判斷成功
      const successMsg = isDraft
        ? '任務暫存成功！'
        : editMode
          ? '任務更新成功！'
          : '推送任務建立成功！'
      console.log('successMsg', successMsg)

      showSuccess(isDraft ? 'draft' : 'save', successMsg)
      alert(successMsg)

      if (!editMode) {
        resetForm()
      } else if (onUpdate) {
        onUpdate(payload)
      }

      // 只有正式提交才關閉 modal 和導航
      if (!isDraft) {
        setShowConfirmModal(false)
      } else if (response.data?.error?.code === '10016') {
        // 處理非會員手機號碼錯誤（參考 ContactSettings.js）
        const errorMessage = response.data.error.message
        console.log('errorMessage', errorMessage)
        const phoneMatch = errorMessage.match(/\((\d+)\)/)
        const invalidPhone = phoneMatch ? phoneMatch[1] : ''

        console.warn('errorMessage:', errorMessage)
        console.warn('非會員手機號碼:', invalidPhone)

        if (formData.recipients.type === 'manual') {
          setErrors((prev) => ({
            ...prev,
            manualPhones: `手機號碼 ${invalidPhone} 不是會員，請檢查號碼或請聯該用戶註冊。您可以移除此號碼後重新提交。`,
          }))

          // 高亮顯示問題號碼
          const currentPhones = manualPhones
          const highlightedPhones = currentPhones.replace(
            new RegExp(invalidPhone, 'g'),
            `【${invalidPhone}】`
          )

          // 自動將問題號碼標記出來，並聚焦到輸入框
          setTimeout(() => {
            const phoneTextarea = document.querySelector(
              'textarea[placeholder*="手機號碼"]'
            )
            if (phoneTextarea) {
              phoneTextarea.focus()
              phoneTextarea.setSelectionRange(
                currentPhones.indexOf(invalidPhone),
                currentPhones.indexOf(invalidPhone) + invalidPhone.length
              )
            }
          }, 100)
        } else if (formData.recipients.type === 'csv') {
          setErrors((prev) => ({
            ...prev,
            recipientMode: `CSV 中的手機號碼 ${invalidPhone} 不是會員，請移除此號碼或請聯該用戶註冊後重新上傳檔案。`,
          }))

          // 從 CSV 數據中移除無效號碼
          // setCsvPhones((prev) => prev.filter((phone) => phone !== invalidPhone))

          // 同時更新 formData
          // setFormData((prev) => ({
          //   ...prev,
          //   recipients: {
          //     ...prev.recipients,
          //     phones: prev.recipients.phones.filter(
          //       (phone) => phone !== invalidPhone
          //     ),
          //   },
          // }))
        }

        // 不關閉 Modal，讓用戶可以修正
        setMessage({
          type: 'error',
          content: `手機號碼 ${invalidPhone} 不是會員，請移除此號碼或請聯該用戶註冊後重新提交。`,
        })
      } else if (response.data?.error?.code === '50004') {
        setMessage({
          type: 'error',
          content: '登入已逾時，請重新登入',
        })
        setLoginShow(true)
      } else {
        // API 返回失敗狀態
        const errorMsg = isDraft
          ? response.data.message || '暫存失敗'
          : response.data.message || '推送任務建立失敗'

        setMessage({
          type: 'error',
          content: errorMsg,
        })
      }
    } catch (error) {
      console.error('提交失敗:', error)

      const errorMsg = isDraft
        ? error.response?.data?.message || '暫存失敗，請稍後再試'
        : error.response?.data?.message || '推送任務建立失敗，請稍後再試'

      setMessage({
        type: 'error',
        content: errorMsg,
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  // 重置表單函數
  const resetForm = () => {
    setFormData({
      taskType: '',
      remark: '',
      taskTitle: '',
      taskDescription: '',
      taskLink: '',
      targetValue: '',
      haCoins: '',
      isTopTask: null,
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
      noEndTime: false,
      repeatOption: null,
      recipients: { type: '', phones: [] },
      exercise_type: '',
    })
    // 清空推送對象相關狀態
    setRecipientMode('')
    setManualPhones('')
    setCsvPhones([])
    setCsvName('')
    setSelectedGroups([])
    setSelectedTags([])
    setSelectedContacts([])

    // 清空其他狀態
    setSelectedTaskPreset(null)
    setErrors({})
    setMessage({ type: '', content: '' })
    setShowConfirmModal(false)
    setShowSuccessModal(false)
  }

  useEffect(() => {
    // 如果不是編輯模式，清空所有表單狀態
    if (!editMode) {
      resetForm()
    }
  }, [editMode])

  // 判斷是否為連結型任務
  const isLinkTypeTask = LINK_TYPE_TASKS.includes(parseInt(formData.taskType))

  // 獲取完成目標的 label 文字
  const getTargetLabel = () => {
    return parseInt(formData.taskType) === 6
      ? '完成目標（分鐘）'
      : '完成目標(當前進度預設為 0)'
  }

  // 獲取目標值的提示文字
  const getTargetPlaceholder = () => {
    if (selectedTaskPreset?.targetPlaceholder) {
      return selectedTaskPreset.targetPlaceholder
    }
    return parseInt(formData.taskType) === 6
      ? '請輸入完成目標（分鐘）'
      : '請輸入完成目標'
  }

  // 確認 Modal 組件（放在 PushTask 組件內部）
  const ConfirmModal = () => {
    if (!showConfirmModal) return null

    // 格式化顯示的資料
    const formatDisplayData = () => {
      const taskTypeName = TASK_PRESETS[formData.taskType]?.name || '未選擇'
      const recipientCount = formData.recipients?.phones?.length || 0
      const recipientTypeText =
        {
          all: '所有使用者',
          contacts: '聯絡⼈清單',
          csv: `CSV 檔案 (${recipientCount} 筆)`,
          manual: `手動輸入 (${recipientCount} 筆)`,
        }[formData.recipients?.type] || '未選擇'

      const repeatOptionText =
        REPEAT_OPTIONS.find((opt) => opt.value === formData.repeatOption)
          ?.label || '未選擇'

      // 取得選中的群組名稱
      const selectedGroupNames = memberGroups
        .filter((group) => selectedGroups.includes(group.member_group_id))
        .map((group) => group.name)

      return {
        taskTypeName,
        recipientTypeText,
        repeatOptionText,
        recipientCount,
        selectedGroupNames,
      }
    }

    const displayData = formatDisplayData()

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}
        onClick={(e) =>
          e.target === e.currentTarget && setShowConfirmModal(false)
        }
      >
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '30px',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          }}
        >
          <h3
            style={{
              marginBottom: '20px',
              color: '#2c3e50',
              textAlign: 'center',
            }}
          >
            確認推送任務資料
          </h3>

          <div style={{ marginBottom: '25px' }}>
            <div style={{ display: 'grid', gap: '15px' }}>
              {/* 任務基本資訊 */}
              <div
                style={{
                  padding: '15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                }}
              >
                <h5 style={{ marginBottom: '12px', color: '#495057' }}>
                  任務資訊
                </h5>
                <div style={{ display: 'grid', gap: '8px', fontSize: '14px' }}>
                  <div>
                    <strong>任務類型：</strong>
                    {displayData.taskTypeName}
                  </div>
                  <div>
                    <strong>備註：</strong>
                    {formData.remark}
                  </div>
                  <div>
                    <strong>任務標題：</strong>
                    {formData.taskTitle}
                  </div>
                  <div>
                    <strong>任務內文：</strong>
                    {formData.taskDescription}
                  </div>
                  <div>
                    <strong>導向頁面：</strong>
                    {formData.taskLink}
                  </div>
                  <div>
                    <strong>完成目標：</strong>
                    {formData.targetValue}
                  </div>
                  <div>
                    <strong>獎勵 HA 幣：</strong>
                    {formData.haCoins}
                  </div>
                  <div>
                    <strong>是否置頂：</strong>
                    {formData.isTopTask ? '是' : '否'}
                  </div>
                </div>
              </div>

              {/* 時間設定 */}
              <div
                style={{
                  padding: '15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                }}
              >
                <h5 style={{ marginBottom: '12px', color: '#495057' }}>
                  時間設定
                </h5>
                <div style={{ display: 'grid', gap: '8px', fontSize: '14px' }}>
                  <div>
                    <strong>開始時間：</strong>
                    {formData.startDate} {formData.startTime}
                  </div>
                  <div>
                    <strong>結束時間：</strong>
                    {formData.noEndTime
                      ? '無結束時間'
                      : `${formData.endDate} ${formData.endTime}`}
                  </div>
                  <div>
                    <strong>重複選項：</strong>
                    {displayData.repeatOptionText}
                  </div>
                </div>
              </div>

              {/* 推送對象 */}
              <div
                style={{
                  padding: '15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                }}
              >
                <h5 style={{ marginBottom: '12px', color: '#495057' }}>
                  推送對象
                </h5>
                <div style={{ display: 'grid', gap: '8px', fontSize: '14px' }}>
                  <div>
                    <strong>對象類型：</strong>
                    {displayData.recipientTypeText}
                  </div>
                  {/* 顯示聯絡人群組名稱 */}
                  {formData.recipients?.type === 'contacts' &&
                    displayData.selectedGroupNames.length > 0 && (
                      <div>
                        <strong>聯絡人群組：</strong>
                        <div
                          style={{
                            marginTop: '4px',
                            padding: '8px',
                            backgroundColor: 'white',
                            borderRadius: '4px',
                            border: '1px solid #dee2e6',
                            fontSize: '13px',
                          }}
                        >
                          {displayData.selectedGroupNames.join('、')}
                        </div>
                      </div>
                    )}

                  {formData.recipients?.type === 'manual' &&
                    formData.recipients.phones.length > 0 && (
                      <div>
                        <strong>手機號碼：</strong>
                        <div
                          style={{
                            marginTop: '8px',
                            padding: '8px',
                            backgroundColor: 'white',
                            borderRadius: '4px',
                            border: '1px solid #dee2e6',
                            maxHeight: '100px',
                            overflow: 'auto',
                            fontSize: '12px',
                          }}
                        >
                          {formData.recipients.phones.join(', ')}
                        </div>
                      </div>
                    )}
                  {displayData.recipientCount > 0 && (
                    <div>
                      <strong>總計：</strong>
                      {displayData.recipientCount} 個號碼
                    </div>
                  )}

                  {/* 顯示非會員錯誤訊息 */}
                  {errors.recipientMode && (
                    <div
                      style={{
                        marginTop: '10px',
                        padding: '10px',
                        backgroundColor: '#f8d7da',
                        color: '#721c24',
                        border: '1px solid #f5c6cb',
                        borderRadius: '4px',
                        fontSize: '13px',
                      }}
                    >
                      ⚠️ {errors.recipientMode}
                    </div>
                  )}

                  {errors.manualPhones && (
                    <div
                      style={{
                        marginTop: '10px',
                        padding: '10px',
                        backgroundColor: '#f8d7da',
                        color: '#721c24',
                        border: '1px solid #f5c6cb',
                        borderRadius: '4px',
                        fontSize: '13px',
                      }}
                    >
                      ⚠️ {errors.manualPhones}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* 按鈕區域 */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '12px',
              paddingTop: '20px',
              borderTop: '1px solid #dee2e6',
            }}
          >
            <button
              type="button"
              onClick={() => setShowConfirmModal(false)}
              style={{
                padding: '10px 20px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              取消
            </button>
            <button
              type="button"
              onClick={handleConfirmSubmit}
              disabled={isSubmitting}
              style={{
                padding: '10px 20px',
                backgroundColor: isSubmitting ? '#6c757d' : '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                fontSize: '14px',
              }}
            >
              {isSubmitting ? '送出中...' : '確認推送任務'}
            </button>
          </div>
        </div>
      </div>
    )
  }

  // 成功 Modal 組件
  const SuccessModal = () => {
    if (!showSuccessModal) return null

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10000, // 比確認 modal 更高
        }}
        onClick={(e) =>
          e.target === e.currentTarget && handleCloseSuccessModal()
        }
      >
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '40px 30px',
            maxWidth: '400px',
            width: '90%',
            textAlign: 'center',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            position: 'relative',
          }}
        >
          {/* 關閉按鈕 */}
          <button
            onClick={handleCloseSuccessModal}
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: '#6c757d',
              padding: '5px',
              borderRadius: '4px',
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#f8f9fa')}
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = 'transparent')
            }
          >
            ✕
          </button>

          {/* 標題 */}
          <h3
            style={{
              marginBottom: '15px',
              color: '#2c3e50',
              fontSize: '20px',
              fontWeight: '600',
            }}
          >
            {successType === 'draft' ? '任務暫存成功' : '任務儲存成功'}
          </h3>

          {/* 訊息內容 */}
          <p
            style={{
              marginBottom: '30px',
              color: '#6c757d',
              fontSize: '16px',
              lineHeight: '1.5',
            }}
          >
            {successMessage}
          </p>

          {/* 確認按鈕 */}
          <button
            onClick={handleCloseSuccessModal}
            style={{
              padding: '12px 30px',
              backgroundColor: '#67c7aa',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'pointer',
              minWidth: '100px',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#49a489')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#67c7aa')}
          >
            確認
          </button>
        </div>
      </div>
    )
  }

  // 處理成功 Modal 關閉
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false)
    setSuccessMessage('')
    setSuccessType('')
  }

  // 顯示成功 Modal 的輔助函數
  const showSuccess = (type, message) => {
    setSuccessType(type)
    setSuccessMessage(message)
    setShowSuccessModal(true)

    // 清除頁面上的 message 狀態

    if (editMode && type === 'save') {
      // 2秒後自動返回任務列表
      setTimeout(() => {
        setShowSuccessModal(false)
        setMessage({ type: '', content: '' })
        if (onUpdate) {
          onUpdate() // 通知父組件更新完成
        }
      }, 2000)
    }
  }

  // =========== 聯絡人 modal ===========
  const openContactsModal = async () => {
    setShowContactsModal(true)
    await fetchMemberGroups()
  }

  // 獲取群組列表
  const fetchMemberGroups = async () => {
    setIsLoadingGroups(true)
    try {
      if (!session) {
        console.warn('Session not found for member groups fetch')
        setLoginShow(true)
        setMessage({
          type: 'error',
          content: '請先登入',
        })
        return
      }

      const response = await axios.get(
        `${baseUrl}/api/backend/memberGroup/getList`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
            session: session,
          },
        }
      )

      console.log('群組列表 API 回應:', response.data)

      if (response.data && response.data.data) {
        setMemberGroups(response.data.data)
        extendCookie() // 延長 session
      } else if (response.data?.error?.code === '50004') {
        setMessage({
          type: 'error',
          content: '登入已逾時，請重新登入',
        })
        setLoginShow(true)
      } else {
        throw new Error('未收到預期的資料格式')
      }
    } catch (error) {
      console.error('獲取群組列表失敗:', error)

      setMessage({
        type: 'error',
        content: '獲取群組列表時發生錯誤',
      })
    } finally {
      setIsLoadingGroups(false)
    }
  }

  // 獲取標籤列表
  const fetchTags = async () => {
    setIsLoadingTags(true)
    try {
      if (!session) {
        console.warn('Session not found for tags fetch')
        setMessage({
          type: 'error',
          content: '請先登入',
        })
        return
      }

      const response = await axios.get(`${baseUrl}/api/backend/getTags`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
          session: session,
        },
      })

      console.log('標籤列表 API 回應:', response.data)

      if (response.data && response.data.data) {
        setTags(response.data.data)
        extendCookie() // 延長 session
      } else if (response.data?.error?.code === '50004') {
        setMessage({
          type: 'error',
          content: '登入已逾時，請重新登入',
        })
        setLoginShow(true)
      } else {
        throw new Error('未收到預期的資料格式')
      }
    } catch (error) {
      console.error('獲取標籤列表失敗:', error)

      setMessage({
        type: 'error',
        content: '獲取標籤列表時發生錯誤',
      })
    } finally {
      setIsLoadingTags(false)
    }
  }

  // 處理標籤頁切換
  const handleTabSwitch = (tab) => {
    setActiveTab(tab)
    setSearchTerm('')

    if (tab === 'tags' && tags.length === 0) {
      fetchTags()
    }

    // 切換頁籤時重置選擇
    if (tab === 'contacts') {
      setSelectedTags([]) // 切換到聯絡人時清空標籤選擇
    } else {
      setSelectedGroups([]) // 切換到標籤時清空群組選擇
    }
  }

  // 處理推送對象模式切換
  const handleRecipientModeChange = (newMode) => {
    // 設置新的推送對象模式
    setRecipientMode(newMode)

    // 清空所有推送對象相關的資料
    if (newMode !== 'members') {
      setManualPhones('')
      setCsvPhones([])
      setCsvName('')
    }

    if (newMode !== 'contacts') {
      setSelectedGroups([]) // 清空已選聯絡人群組
    }

    // 清空相關錯誤訊息
    setErrors((prev) => ({
      ...prev,
      recipientMode: '',
      manualPhones: '',
      csvFile: '',
    }))

    // 重置檔案輸入框
    const fileInput = document.querySelector('input[type="file"]')
    if (fileInput) {
      fileInput.value = ''
    }
  }

  // 會員查詢函數
  const handleSearchMember = async () => {
    if (!memberSearchPhone || memberSearchPhone.length < 10) {
      setMemberSearchError('請輸入完整的手機號碼')
      return
    }

    setIsSearchingMember(true)
    setMemberSearchError('')
    setSearchedMember(null)

    try {
      const requestData = {
        phone: memberSearchPhone,
        size: 1,
        page: 1,
        with_full_info: 0,
      }

      const response = await axios.post(
        `${baseUrl}/api/backend/member/getList`,
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
            session: session,
          },
        }
      )

      extendCookie()

      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        setSearchedMember(response.data.data[0])
      } else if (response.data?.error?.code === '50004') {
        setMemberSearchError('登入已逾時，請重新登入')
        setLoginShow(true)
      } else {
        setMemberSearchError('未找到該手機號碼的會員資料')
      }
    } catch (error) {
      console.error('查詢會員失敗:', error)

      setMemberSearchError(
        error.response?.data?.message || '查詢失敗，請稍後再試'
      )
    } finally {
      setIsSearchingMember(false)
    }
  }

  // 處理Enter鍵查詢
  const handleSearchKeyPress = (e) => {
    if (
      e.key === 'Enter' &&
      !isSearchingMember &&
      memberSearchPhone &&
      memberSearchPhone.length >= 10
    ) {
      handleSearchMember()
    }
  }

  // 如果正在載入任務資料，顯示載入狀態
  if (editMode && isLoadingTask) {
    return (
      <Container fluid className="py-4" style={{ maxWidth: '1400px' }}>
        <div className="m-5">
          <ProgressBar className="m-4" animated now={100} />
          <h5 className="text-secondary text-center">資料等待中...</h5>
        </div>
      </Container>
    )
  }

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h2 style={{ color: '#2c3e50', marginBottom: '10px' }}>
          {editMode
            ? `編輯 ${taskData?.id} 任務${getStatusText(taskData?.status)}`
            : '推送任務'}
        </h2>
      </div>

      {message.content && (
        <div
          style={{
            padding: '12px 16px',
            marginBottom: '20px',
            borderRadius: '8px',
            backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
            border: `1px solid ${message.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
            color: message.type === 'success' ? '#155724' : '#721c24',
          }}
        >
          {message.content}
        </div>
      )}

      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          padding: '30px',
        }}
      >
        <div onSubmit={handleShowConfirm}>
          {/* 指定任務區塊 */}
          <div style={{ marginBottom: '30px' }}>
            <h5 style={{ marginBottom: '20px', color: '#2c3e50' }}>指定任務</h5>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '20px',
                marginBottom: '20px',
              }}
            >
              <div>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: '500',
                  }}
                >
                  任務類型
                </label>
                <select
                  value={formData.taskType}
                  onChange={handleTaskTypeChange}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.taskType
                      ? '2px solid #dc3545'
                      : '1px solid #ddd',
                    borderRadius: '6px',
                    fontSize: '14px',
                  }}
                >
                  <option value="">請選擇任務類型</option>
                  {Object.entries(TASK_PRESETS).map(([type, data]) => (
                    <option key={type} value={type}>
                      {data.name}
                    </option>
                  ))}
                </select>
                {errors.taskType && (
                  <div
                    style={{
                      color: '#dc3545',
                      fontSize: '12px',
                      marginTop: '4px',
                    }}
                  >
                    {errors.taskType}
                  </div>
                )}
              </div>

              {/* 運動項目選擇（僅當任務類型為運動時顯示） */}
              {formData.taskType === '6' && (
                <div style={{ marginBottom: '20px' }}>
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                    }}
                  >
                    運動項目
                  </label>
                  <select
                    name="exercise_type"
                    value={formData.exercise_type}
                    onChange={(e) =>
                      handleInputChange('exercise_type', e.target.value)
                    }
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: errors.exercise_type
                        ? '2px solid red'
                        : '1px solid #ddd',
                      borderRadius: '6px',
                      fontSize: '14px',
                    }}
                  >
                    <option value="">請選擇運動項目</option>
                    {EXERCISE_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {errors.exercise_type && (
                    <div
                      style={{
                        color: 'red',
                        fontSize: '14px',
                        marginTop: '4px',
                      }}
                    >
                      {errors.exercise_type}
                    </div>
                  )}
                </div>
              )}

              <div>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: '500',
                  }}
                >
                  備註(只有後台使用者可檢視)
                </label>
                <input
                  type="text"
                  placeholder="建議輸入專案名稱或對象"
                  value={formData.remark}
                  onChange={(e) => handleInputChange('remark', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.remark
                      ? '2px solid #dc3545'
                      : '1px solid #ddd',
                    borderRadius: '6px',
                    fontSize: '14px',
                  }}
                />
                {errors.remark && (
                  <div
                    style={{
                      color: '#dc3545',
                      fontSize: '12px',
                      marginTop: '4px',
                    }}
                  >
                    {errors.remark}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* 任務詳細設定區塊 */}
          <div
            style={{
              backgroundColor: '#f8f9fa',
              padding: '25px',
              borderRadius: '10px',
              marginBottom: '30px',
            }}
          >
            <div style={{ marginBottom: '20px' }}>
              <label
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: '500',
                }}
              >
                任務標題
              </label>
              <input
                type="text"
                placeholder="請輸入任務標題"
                value={formData.taskTitle}
                onChange={(e) => handleInputChange('taskTitle', e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: errors.taskTitle
                    ? '2px solid #dc3545'
                    : '1px solid #ddd',
                  borderRadius: '6px',
                  fontSize: '14px',
                }}
              />
              {errors.taskTitle && (
                <div
                  style={{
                    color: '#dc3545',
                    fontSize: '12px',
                    marginTop: '4px',
                  }}
                >
                  {errors.taskTitle}
                </div>
              )}
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: '500',
                }}
              >
                任務內文
              </label>
              <textarea
                rows={3}
                placeholder="請輸入任務內文"
                value={formData.taskDescription}
                onChange={(e) =>
                  handleInputChange('taskDescription', e.target.value)
                }
                style={{
                  width: '100%',
                  padding: '10px',
                  border: errors.taskDescription
                    ? '2px solid #dc3545'
                    : '1px solid #ddd',
                  borderRadius: '6px',
                  fontSize: '14px',
                  resize: 'vertical',
                }}
              />
              {errors.taskDescription && (
                <div
                  style={{
                    color: '#dc3545',
                    fontSize: '12px',
                    marginTop: '4px',
                  }}
                >
                  {errors.taskDescription}
                </div>
              )}
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: '500',
                }}
              >
                任務導向頁面
              </label>
              <input
                type="text"
                placeholder={
                  isLinkTypeTask ? '請輸入任務導向網頁連結' : 'App 頁面'
                }
                value={formData.taskLink}
                onChange={(e) => handleInputChange('taskLink', e.target.value)}
                disabled={!isLinkTypeTask}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: errors.taskLink
                    ? '2px solid #dc3545'
                    : '1px solid #ddd',
                  borderRadius: '6px',
                  fontSize: '14px',
                  backgroundColor: !isLinkTypeTask ? '#f8f9fa' : 'white',
                  color: !isLinkTypeTask ? '#6c757d' : 'inherit',
                }}
              />
              {errors.taskLink && (
                <div
                  style={{
                    color: '#dc3545',
                    fontSize: '12px',
                    marginTop: '4px',
                  }}
                >
                  {errors.taskLink}
                </div>
              )}
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '20px',
                marginBottom: '20px',
              }}
            >
              <div>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: '500',
                  }}
                >
                  {getTargetLabel()}
                </label>
                <input
                  type="number"
                  placeholder={getTargetPlaceholder()}
                  value={formData.targetValue}
                  onChange={(e) =>
                    handleInputChange('targetValue', e.target.value)
                  }
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.targetValue
                      ? '2px solid #dc3545'
                      : '1px solid #ddd',
                    borderRadius: '6px',
                    fontSize: '14px',
                  }}
                />
                {errors.targetValue && (
                  <div
                    style={{
                      color: '#dc3545',
                      fontSize: '12px',
                      marginTop: '4px',
                    }}
                  >
                    {errors.targetValue}
                  </div>
                )}
              </div>

              <div>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: '500',
                  }}
                >
                  獎勵 HA 幣
                </label>
                <input
                  type="number"
                  placeholder="請輸入獎勵 HA 幣"
                  value={formData.haCoins}
                  onChange={(e) => handleInputChange('haCoins', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: errors.haCoins
                      ? '2px solid #dc3545'
                      : '1px solid #ddd',
                    borderRadius: '6px',
                    fontSize: '14px',
                  }}
                />
                {errors.haCoins && (
                  <div
                    style={{
                      color: '#dc3545',
                      fontSize: '12px',
                      marginTop: '4px',
                    }}
                  >
                    {errors.haCoins}
                  </div>
                )}
              </div>
            </div>

            <div>
              <label
                style={{
                  display: 'block',
                  marginBottom: '12px',
                  fontWeight: '500',
                }}
              >
                是否置頂
              </label>
              <div style={{ display: 'flex', gap: '20px' }}>
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <input
                    type="radio"
                    name="isTopTask"
                    checked={formData.isTopTask === false}
                    onChange={() => handleInputChange('isTopTask', false)}
                    style={{ marginRight: '8px' }}
                  />
                  不置頂
                </label>
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <input
                    type="radio"
                    name="isTopTask"
                    checked={formData.isTopTask === true}
                    onChange={() => handleInputChange('isTopTask', true)}
                    style={{ marginRight: '8px' }}
                  />
                  置頂
                </label>
              </div>
              {errors.isTopTask && (
                <div
                  style={{
                    color: '#dc3545',
                    fontSize: '12px',
                    marginTop: '4px',
                  }}
                >
                  {errors.isTopTask}
                </div>
              )}
            </div>
          </div>

          {/* 指定任務出現時間區塊 */}
          <div style={{ marginBottom: '30px' }}>
            <h5 style={{ marginBottom: '20px', color: '#2c3e50' }}>
              指定任務出現時間
            </h5>

            <div
              style={{
                backgroundColor: '#f8f9fa',
                padding: '25px',
                borderRadius: '10px',
              }}
            >
              {/* 開始時間 */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '20px',
                  marginBottom: '20px',
                }}
              >
                <div>
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontWeight: '500',
                    }}
                  >
                    開始日期
                  </label>
                  <input
                    type="date"
                    value={formData.startDate}
                    onChange={(e) =>
                      handleInputChange('startDate', e.target.value)
                    }
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: errors.startDate
                        ? '2px solid #dc3545'
                        : '1px solid #ddd',
                      borderRadius: '6px',
                      fontSize: '14px',
                    }}
                  />
                  {errors.startDate && (
                    <div
                      style={{
                        color: '#dc3545',
                        fontSize: '12px',
                        marginTop: '4px',
                      }}
                    >
                      {errors.startDate}
                    </div>
                  )}
                </div>

                <div>
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontWeight: '500',
                    }}
                  >
                    開始時間
                  </label>
                  <input
                    type="time"
                    value={formData.startTime}
                    onChange={(e) =>
                      handleInputChange('startTime', e.target.value)
                    }
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: errors.startTime
                        ? '2px solid #dc3545'
                        : '1px solid #ddd',
                      borderRadius: '6px',
                      fontSize: '14px',
                    }}
                  />
                  {errors.startTime && (
                    <div
                      style={{
                        color: '#dc3545',
                        fontSize: '12px',
                        marginTop: '4px',
                      }}
                    >
                      {errors.startTime}
                    </div>
                  )}
                </div>
              </div>

              {/* 結束時間 */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '20px',
                  marginBottom: '20px',
                }}
              >
                <div>
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontWeight: '500',
                    }}
                  >
                    結束日期
                  </label>
                  <input
                    type="date"
                    value={formData.endDate || ''}
                    onChange={(e) =>
                      handleInputChange('endDate', e.target.value)
                    }
                    disabled={formData.noEndTime}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: errors.endDate
                        ? '2px solid #dc3545'
                        : '1px solid #ddd',
                      borderRadius: '6px',
                      fontSize: '14px',
                      backgroundColor: formData.noEndTime ? '#f8f9fa' : 'white',
                      color: formData.noEndTime ? '#6c757d' : 'inherit',
                    }}
                  />
                  {errors.endDate && (
                    <div
                      style={{
                        color: '#dc3545',
                        fontSize: '12px',
                        marginTop: '4px',
                      }}
                    >
                      {errors.endDate}
                    </div>
                  )}
                </div>

                <div>
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontWeight: '500',
                    }}
                  >
                    結束時間
                  </label>
                  <input
                    type="time"
                    value={formData.endTime || ''}
                    onChange={(e) =>
                      handleInputChange('endTime', e.target.value)
                    }
                    disabled={formData.noEndTime}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: errors.endTime
                        ? '2px solid #dc3545'
                        : '1px solid #ddd',
                      borderRadius: '6px',
                      fontSize: '14px',
                      backgroundColor: formData.noEndTime ? '#f8f9fa' : 'white',
                      color: formData.noEndTime ? '#6c757d' : 'inherit',
                    }}
                  />
                  {errors.endTime && (
                    <div
                      style={{
                        color: '#dc3545',
                        fontSize: '12px',
                        marginTop: '4px',
                      }}
                    >
                      {errors.endTime}
                    </div>
                  )}
                </div>
              </div>

              {/* 無結束時間選項 */}
              <div style={{ marginBottom: '20px' }}>
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    fontWeight: '500',
                  }}
                >
                  <input
                    type="checkbox"
                    checked={formData.noEndTime}
                    onChange={handleNoEndTimeChange}
                    style={{ marginRight: '8px' }}
                  />
                  無結束時間
                </label>
              </div>

              {/* 重複選項 */}
              <div>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '12px',
                    fontWeight: '500',
                  }}
                >
                  重複選項
                </label>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                  }}
                >
                  {REPEAT_OPTIONS.map((option) => (
                    <label
                      key={option.value}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <input
                        type="radio"
                        name="repeatOption"
                        value={option.value}
                        checked={formData.repeatOption === option.value}
                        onChange={(e) =>
                          handleInputChange('repeatOption', e.target.value)
                        }
                        style={{ marginRight: '8px' }}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
                {errors.repeatOption && (
                  <div
                    style={{
                      color: '#dc3545',
                      fontSize: '12px',
                      marginTop: '4px',
                    }}
                  >
                    {errors.repeatOption}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* 指定任務推送對象 */}
          <div style={{ marginBottom: '30px' }}>
            <h5 style={{ marginBottom: '20px', color: '#2c3e50' }}>
              指定任務推送對象
            </h5>

            <div
              style={{
                backgroundColor: '#f8f9fa',
                padding: 20,
                borderRadius: 10,
              }}
            >
              {editMode ? (
                /* 編輯模式 - 顯示推送對象電話號碼列表 */
                <div>
                  {/* 當有電話列表時顯示搜尋功能 */}
                  {formData.recipients?.phones &&
                    formData.recipients.phones.length > 0 && (
                      <div>
                        {/* 推送對象信息 */}
                        <div
                          style={{
                            // padding: '16px',
                            backgroundColor: '#f8f9fa',
                            // border: '1px solid #dee2e6',
                            borderRadius: '6px',
                            marginBottom: '16px',
                          }}
                        >
                          {/* 會員查詢區域 */}
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px',
                            }}
                          >
                            <input
                              type="text"
                              placeholder="輸入手機號碼查詢會員（例：0912345678）"
                              value={memberSearchPhone}
                              onChange={(e) =>
                                setMemberSearchPhone(
                                  e.target.value.replace(/[^0-9]/g, '')
                                )
                              }
                              onKeyPress={handleSearchKeyPress}
                              style={{
                                flex: 1,
                                padding: '8px 12px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px',
                              }}
                              maxLength={10}
                            />
                            <button
                              type="button"
                              onClick={handleSearchMember}
                              disabled={
                                isSearchingMember ||
                                !memberSearchPhone ||
                                memberSearchPhone.length < 10
                              }
                              style={{
                                padding: '8px 16px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                opacity:
                                  isSearchingMember ||
                                  !memberSearchPhone ||
                                  memberSearchPhone.length < 10
                                    ? 0.6
                                    : 1,
                              }}
                            >
                              {isSearchingMember ? '查詢中...' : '查詢'}
                            </button>
                          </div>

                          {/* 查詢錯誤訊息 */}
                          {memberSearchError && (
                            <div
                              style={{
                                marginTop: '8px',
                                padding: '8px',
                                backgroundColor: '#f8d7da',
                                border: '1px solid #f5c6cb',
                                borderRadius: '4px',
                                color: '#721c24',
                                fontSize: '14px',
                              }}
                            >
                              {memberSearchError}
                            </div>
                          )}

                          {/* 檢查該電話是否在推送列表中 */}
                          {memberSearchPhone &&
                            memberSearchPhone.length === 10 && (
                              <div
                                style={{
                                  marginTop: '8px',
                                  padding: '8px',
                                  backgroundColor:
                                    formData.recipients.phones.includes(
                                      memberSearchPhone
                                    )
                                      ? '#fff'
                                      : '#fff3cd',
                                  border: `1px solid ${
                                    formData.recipients.phones.includes(
                                      memberSearchPhone
                                    )
                                      ? '#ddd'
                                      : '#ffeaa7'
                                  }`,
                                  borderRadius: '4px',
                                  fontSize: '14px',
                                  color: formData.recipients.phones.includes(
                                    memberSearchPhone
                                  )
                                    ? '#212529'
                                    : '#856404',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <span>
                                  {formData.recipients.phones.includes(
                                    memberSearchPhone
                                  )
                                    ? `${memberSearchPhone}`
                                    : `⚠ 此號碼 ${memberSearchPhone} 不在推送列表中`}
                                </span>

                                {/* 刪除按鈕 - 只有在找到電話號碼時才顯示 */}
                                {formData.recipients.phones.includes(
                                  memberSearchPhone
                                ) && (
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setShowDeletePhoneModal(true)
                                    }
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      color: '#dc3545',
                                      cursor: 'pointer',
                                      padding: '4px 8px',
                                      borderRadius: '4px',
                                      fontSize: '16px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      transition: 'background-color 0.2s',
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.backgroundColor =
                                        'rgba(220, 53, 69, 0.1)'
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.backgroundColor =
                                        'transparent'
                                    }}
                                    title="從推送列表中刪除此號碼"
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                  </button>
                                )}
                              </div>
                            )}

                          {/* 刪除電話號碼確認 Modal */}
                          <Modal
                            show={showDeletePhoneModal}
                            onHide={() => setShowDeletePhoneModal(false)}
                            centered
                            size="lg"
                          >
                            <Modal.Header
                              closeButton
                              style={{
                                backgroundColor: 'white',
                              }}
                            >
                              <Modal.Title
                                style={{
                                  width: '100%',
                                  textAlign: 'center',
                                  margin: 0,
                                  color: '#2c3e50',
                                }}
                              >
                                刪除電話號碼
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="text-center py-5">
                              <div>
                                <p
                                  className="mb-0"
                                  style={{ fontSize: '16px' }}
                                >
                                  請確認是否從推送列表中刪除電話號碼「
                                  <span
                                    style={{
                                      fontFamily: 'monospace',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {memberSearchPhone}
                                  </span>
                                  」？
                                </p>
                                {searchedMember && (
                                  <p
                                    className="mt-3 mb-0"
                                    style={{
                                      fontSize: '14px',
                                      color: '#6c757d',
                                    }}
                                  >
                                    會員：{searchedMember.name} (ID:{' '}
                                    {searchedMember.member_id})
                                  </p>
                                )}
                              </div>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                variant="secondary"
                                onClick={() => setShowDeletePhoneModal(false)}
                              >
                                取消
                              </Button>
                              <Button
                                variant="danger"
                                onClick={() => {
                                  setIsSubmitting(true)

                                  try {
                                    // 檢查當前的 send_type
                                    if (
                                      formData.recipients.sendType === 0 ||
                                      formData.recipients.sendType === 1
                                    ) {
                                      // 當 send_type=0 or 1 時，將電話號碼加入排除清單
                                      const currentExcludeList =
                                        formData.excludeMemberList || []

                                      const updatedExcludeList = [
                                        ...currentExcludeList,
                                        memberSearchPhone,
                                      ]

                                      setFormData((prev) => ({
                                        ...prev,
                                        excludeMemberList: updatedExcludeList, // 新增到排除清單
                                      }))

                                      console.log(
                                        'currentExcludeList',
                                        currentExcludeList
                                      )

                                      console.log(
                                        '電話號碼已加入排除清單:',
                                        memberSearchPhone
                                      )
                                      console.log(
                                        '更新後排除清單:',
                                        updatedExcludeList
                                      )
                                    } else {
                                      // 原有邏輯：send_type=2 時的處理方式保持不變
                                      const updatedPhones =
                                        formData.recipients.phones.filter(
                                          (phone) => phone !== memberSearchPhone
                                        )

                                      setFormData((prev) => ({
                                        ...prev,
                                        recipients: {
                                          sendType: 2,
                                          type: 'members',
                                          phones: updatedPhones,
                                          memberGroups: [],
                                        },
                                      }))

                                      console.log(
                                        '刪除電話號碼:',
                                        memberSearchPhone
                                      )
                                      console.log(
                                        '更新後電話列表:',
                                        updatedPhones
                                      )
                                    }

                                    setShowDeletePhoneModal(false)
                                    setMemberSearchPhone('')
                                    setSearchedMember(null)
                                  } catch (error) {
                                    console.error(
                                      '刪除電話號碼時發生錯誤:',
                                      error
                                    )
                                  } finally {
                                    setIsSubmitting(false)
                                  }
                                }}
                                disabled={isSubmitting}
                                className="px-4"
                              >
                                {isSubmitting ? (
                                  <>
                                    <Spinner
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      className="me-2"
                                    />
                                    刪除中...
                                  </>
                                ) : (
                                  <>確認刪除</>
                                )}
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </div>

                        {/* 查詢結果顯示 */}
                        {searchedMember && (
                          <div
                            style={{
                              border: '1px solid #dee2e6',
                              borderRadius: '6px',
                              backgroundColor: 'white',
                              marginBottom: '16px',
                            }}
                          >
                            <div
                              style={{
                                padding: '12px 16px',
                                backgroundColor: '#e8f5e8',
                                borderBottom: '1px solid #dee2e6',
                                fontWeight: '600',
                                color: '#155724',
                              }}
                            >
                              查詢結果
                            </div>
                            <div
                              style={{
                                padding: '16px',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                }}
                              >
                                {/* 左側會員資訊 */}
                                <div
                                  style={{
                                    display: 'grid',
                                    gap: '8px',
                                    fontSize: '14px',
                                    flex: 1,
                                  }}
                                >
                                  <div>
                                    <span
                                      style={{
                                        fontWeight: '500',
                                        color: '#495057',
                                      }}
                                    >
                                      會員ID：
                                    </span>
                                    <span style={{ color: '#2c3e50' }}>
                                      {searchedMember.member_id}
                                    </span>
                                  </div>
                                  <div>
                                    <span
                                      style={{
                                        fontWeight: '500',
                                        color: '#495057',
                                      }}
                                    >
                                      姓名：
                                    </span>
                                    <span style={{ color: '#2c3e50' }}>
                                      {searchedMember.name}
                                    </span>
                                  </div>
                                  <div>
                                    <span
                                      style={{
                                        fontWeight: '500',
                                        color: '#495057',
                                      }}
                                    >
                                      手機號碼：
                                    </span>
                                    <span
                                      style={{
                                        color: '#2c3e50',
                                        fontFamily: 'monospace',
                                      }}
                                    >
                                      {searchedMember.phone}
                                    </span>
                                  </div>
                                  <div>
                                    <span
                                      style={{
                                        fontWeight: '500',
                                        color: '#495057',
                                      }}
                                    >
                                      推送狀態：
                                    </span>
                                    <span
                                      style={{
                                        color:
                                          formData.excludeMemberList &&
                                          formData.excludeMemberList.includes(
                                            searchedMember.phone
                                          )
                                            ? '#dc3545'
                                            : '#28a745',
                                        fontWeight: '500',
                                      }}
                                    >
                                      {formData.excludeMemberList &&
                                      formData.excludeMemberList.includes(
                                        searchedMember.phone
                                      )
                                        ? '✗ 不會收到此任務推送（已排除）'
                                        : '✓ 會收到此任務推送'}
                                    </span>
                                  </div>
                                </div>

                                {/* 右側刪除按鈕 */}
                                <div
                                  style={{
                                    marginLeft: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setShowDeletePhoneModal(true)
                                    }
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      color: '#dc3545',
                                      cursor: 'pointer',
                                      padding: '8px',
                                      borderRadius: '4px',
                                      fontSize: '16px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      transition: 'background-color 0.2s',
                                      width: '40px',
                                      height: '40px',
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.backgroundColor =
                                        'rgba(220, 53, 69, 0.1)'
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.backgroundColor =
                                        'transparent'
                                    }}
                                    title="從推送列表中刪除此號碼"
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* 推送對象電話號碼列表 */}
                        <div>
                          <div
                            style={{
                              marginBottom: '12px',
                              fontWeight: '500',
                              color: '#495057',
                            }}
                          >
                            推送對象電話號碼 (
                            {formData.recipients.phones.length} 筆)：
                          </div>

                          <div
                            style={{
                              maxHeight: '300px',
                              overflowY: 'auto',
                              border: '1px solid #dee2e6',
                              borderRadius: '6px',
                              backgroundColor: 'white',
                            }}
                          >
                            {/* 表頭 */}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '12px 16px',
                                backgroundColor: '#f8f9fa',
                                borderBottom: '1px solid #dee2e6',
                                fontWeight: '600',
                                color: '#495057',
                                position: 'sticky',
                                top: 0,
                                zIndex: 1,
                              }}
                            >
                              <div
                                style={{ width: '60px', textAlign: 'center' }}
                              >
                                序號
                              </div>
                              <div
                                style={{
                                  flex: 1,
                                  textAlign: 'left',
                                  marginLeft: '16px',
                                }}
                              >
                                電話號碼
                              </div>
                            </div>

                            {/* 電話號碼列表項目 */}
                            {formData.recipients.phones.map((phone, index) => (
                              <div
                                key={index}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding: '12px 16px',
                                  borderBottom:
                                    index <
                                    formData.recipients.phones.length - 1
                                      ? '1px solid #f1f3f4'
                                      : 'none',
                                  backgroundColor:
                                    phone === memberSearchPhone
                                      ? '#fff3cd'
                                      : index % 2 === 0
                                        ? '#ffffff'
                                        : '#f8f9fa',
                                }}
                              >
                                <div
                                  style={{
                                    width: '60px',
                                    textAlign: 'center',
                                    color: '#6c757d',
                                    fontSize: '14px',
                                  }}
                                >
                                  {index + 1}
                                </div>
                                <div
                                  style={{
                                    flex: 1,
                                    marginLeft: '16px',
                                    fontSize: '14px',
                                    color: '#2c3e50',
                                    fontFamily: 'monospace',
                                  }}
                                >
                                  {phone}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  {/* 沒有推送對象的情況 */}
                  {/* 所有使用者的查詢功能 */}
                  {formData.recipients?.type === 'all' && (
                    <div>
                      <div
                        style={{
                          padding: '16px',
                          backgroundColor: '#f8f9fa',
                          border: '1px solid #dee2e6',
                          borderRadius: '6px',
                          marginBottom: '16px',
                        }}
                      >
                        <div style={{ color: '#6c757d', marginBottom: '12px' }}>
                          推送給所有使用者 - 查詢特定會員(請填寫完整手機號碼)
                        </div>

                        {/* 會員查詢區域 */}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                          }}
                        >
                          <input
                            type="text"
                            placeholder="輸入手機號碼查詢會員（例：0912345678）"
                            value={memberSearchPhone}
                            onChange={(e) =>
                              setMemberSearchPhone(
                                e.target.value.replace(/[^0-9]/g, '')
                              )
                            }
                            onKeyPress={handleSearchKeyPress}
                            style={{
                              flex: 1,
                              padding: '8px 12px',
                              border: '1px solid #ddd',
                              borderRadius: '4px',
                              fontSize: '14px',
                            }}
                            maxLength={10}
                          />
                          <button
                            type="button"
                            onClick={handleSearchMember}
                            disabled={
                              isSearchingMember ||
                              !memberSearchPhone ||
                              memberSearchPhone.length < 10
                            }
                            style={{
                              padding: '8px 16px',
                              backgroundColor: '#007bff',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '14px',
                              opacity:
                                isSearchingMember ||
                                !memberSearchPhone ||
                                memberSearchPhone.length < 10
                                  ? 0.6
                                  : 1,
                            }}
                          >
                            {isSearchingMember ? '查詢中...' : '查詢'}
                          </button>
                        </div>

                        {/* 查詢錯誤訊息 */}
                        {memberSearchError && (
                          <div
                            style={{
                              marginTop: '8px',
                              padding: '8px',
                              backgroundColor: '#f8d7da',
                              border: '1px solid #f5c6cb',
                              borderRadius: '4px',
                              color: '#721c24',
                              fontSize: '14px',
                            }}
                          >
                            {memberSearchError}
                          </div>
                        )}
                      </div>

                      {/* 查詢結果顯示 */}
                      {searchedMember && (
                        <div
                          style={{
                            border: '1px solid #dee2e6',
                            borderRadius: '6px',
                            backgroundColor: 'white',
                          }}
                        >
                          <div
                            style={{
                              padding: '12px 16px',
                              backgroundColor: '#e8f5e8',
                              borderBottom: '1px solid #dee2e6',
                              fontWeight: '600',
                              color: '#155724',
                            }}
                          >
                            查詢結果
                          </div>
                          <div
                            style={{
                              padding: '16px',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                              }}
                            >
                              {/* 左側會員資訊 */}
                              <div
                                style={{
                                  display: 'grid',
                                  gap: '8px',
                                  fontSize: '14px',
                                  flex: 1,
                                }}
                              >
                                <div>
                                  <span
                                    style={{
                                      fontWeight: '500',
                                      color: '#495057',
                                    }}
                                  >
                                    會員ID：
                                  </span>
                                  <span style={{ color: '#2c3e50' }}>
                                    {searchedMember.member_id}
                                  </span>
                                </div>
                                <div>
                                  <span
                                    style={{
                                      fontWeight: '500',
                                      color: '#495057',
                                    }}
                                  >
                                    姓名：
                                  </span>
                                  <span style={{ color: '#2c3e50' }}>
                                    {searchedMember.name}
                                  </span>
                                </div>
                                <div>
                                  <span
                                    style={{
                                      fontWeight: '500',
                                      color: '#495057',
                                    }}
                                  >
                                    手機號碼：
                                  </span>
                                  <span
                                    style={{
                                      color: '#2c3e50',
                                      fontFamily: 'monospace',
                                    }}
                                  >
                                    {searchedMember.phone}
                                  </span>
                                </div>
                                <div>
                                  <span
                                    style={{
                                      fontWeight: '500',
                                      color: '#495057',
                                    }}
                                  >
                                    推送狀態：
                                  </span>
                                  <span
                                    style={{
                                      color:
                                        formData.excludeMemberList &&
                                        formData.excludeMemberList.includes(
                                          searchedMember.phone
                                        )
                                          ? '#dc3545'
                                          : '#28a745',
                                      fontWeight: '500',
                                    }}
                                  >
                                    {formData.excludeMemberList &&
                                    formData.excludeMemberList.includes(
                                      searchedMember.phone
                                    )
                                      ? '✗ 不會收到此任務推送（已排除）'
                                      : '✓ 會收到此任務推送'}
                                  </span>
                                </div>
                              </div>

                              {/* 右側刪除按鈕 */}
                              <div
                                style={{
                                  marginLeft: '16px',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() => setShowDeletePhoneModal(true)}
                                  style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#dc3545',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    borderRadius: '4px',
                                    fontSize: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'background-color 0.2s',
                                    width: '40px',
                                    height: '40px',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.backgroundColor =
                                      'rgba(220, 53, 69, 0.1)'
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.backgroundColor =
                                      'transparent'
                                  }}
                                  title="從推送列表中刪除此號碼"
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 刪除電話號碼確認 Modal */}
                      <Modal
                        show={showDeletePhoneModal}
                        onHide={() => setShowDeletePhoneModal(false)}
                        centered
                        size="lg"
                      >
                        <Modal.Header
                          closeButton
                          style={{
                            backgroundColor: 'white',
                          }}
                        >
                          <Modal.Title
                            style={{
                              width: '100%',
                              textAlign: 'center',
                              margin: 0,
                              color: '#2c3e50',
                            }}
                          >
                            刪除電話號碼
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-center py-5">
                          <div>
                            <p className="mb-0" style={{ fontSize: '16px' }}>
                              請確認是否從推送列表中刪除電話號碼「
                              <span
                                style={{
                                  fontFamily: 'monospace',
                                  fontWeight: 'bold',
                                }}
                              >
                                {memberSearchPhone}
                              </span>
                              」？
                            </p>
                            {searchedMember && (
                              <p
                                className="mt-3 mb-0"
                                style={{
                                  fontSize: '14px',
                                  color: '#6c757d',
                                }}
                              >
                                會員：{searchedMember.name} (ID:{' '}
                                {searchedMember.member_id})
                              </p>
                            )}
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => setShowDeletePhoneModal(false)}
                          >
                            取消
                          </Button>
                          <Button
                            variant="danger"
                            onClick={() => {
                              setIsSubmitting(true)

                              try {
                                // 檢查當前的 send_type
                                if (
                                  formData.recipients.sendType === 0 ||
                                  formData.recipients.sendType === 1
                                ) {
                                  // 當 send_type=0 or 1 時，將電話號碼加入排除清單
                                  const currentExcludeList =
                                    formData.excludeMemberList || []
                                  const updatedExcludeList = [
                                    ...currentExcludeList,
                                    memberSearchPhone,
                                  ]

                                  setFormData((prev) => ({
                                    ...prev,
                                    excludeMemberList: updatedExcludeList, // 新增到排除清單
                                  }))

                                  console.log(
                                    '電話號碼已加入排除清單:',
                                    memberSearchPhone
                                  )
                                  console.log(
                                    '更新後排除清單:',
                                    updatedExcludeList
                                  )
                                } else {
                                  // 原有邏輯：send_type=2 時的處理方式保持不變
                                  const updatedPhones =
                                    formData.recipients.phones.filter(
                                      (phone) => phone !== memberSearchPhone
                                    )

                                  setFormData((prev) => ({
                                    ...prev,
                                    recipients: {
                                      sendType: 2,
                                      type: 'members',
                                      phones: updatedPhones,
                                      memberGroups: [],
                                    },
                                  }))

                                  console.log(
                                    '刪除電話號碼:',
                                    memberSearchPhone
                                  )
                                  console.log('更新後電話列表:', updatedPhones)
                                }

                                setShowDeletePhoneModal(false)
                                setMemberSearchPhone('')
                                setSearchedMember(null)
                              } catch (error) {
                                console.error('刪除電話號碼時發生錯誤:', error)
                              } finally {
                                setIsSubmitting(false)
                              }
                            }}
                            disabled={isSubmitting}
                            className="px-4"
                          >
                            {isSubmitting ? (
                              <>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  className="me-2"
                                />
                                刪除中...
                              </>
                            ) : (
                              <>確認刪除</>
                            )}
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  )}
                  {(!formData.recipients?.phones ||
                    formData.recipients.phones.length === 0) &&
                    formData.recipients?.type !== 'all' && (
                      <div
                        style={{
                          padding: '20px',
                          textAlign: 'center',
                          backgroundColor: '#fff3cd',
                          border: '1px solid #ffeeba',
                          borderRadius: '6px',
                          color: '#856404',
                        }}
                      >
                        未找到推送對象電話號碼
                      </div>
                    )}
                  {/* 顯示已排除的電話號碼清單 */}
                  {formData.excludeMemberList &&
                    formData.excludeMemberList.length > 0 && (
                      <div className="excluded-members-section">
                        <div
                          style={{
                            marginTop: '12px',
                            marginBottom: '12px',
                            fontWeight: '500',
                            color: '#495057',
                          }}
                        >
                          已排除的會員電話：
                        </div>
                        <div className="excluded-phones-list">
                          {formData.excludeMemberList.map((phone, index) => (
                            <span key={index} className="excluded-phone-tag">
                              {phone}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                </div>
              ) : (
                <div>
                  {/* 1. 所有使用者 */}
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 14,
                      cursor: 'pointer',
                    }}
                  >
                    <input
                      type="radio"
                      name="recipientMode"
                      checked={recipientMode === 'all'}
                      onChange={() => handleRecipientModeChange('all')}
                      style={{ marginRight: 8 }}
                    />
                    所有使用者
                  </label>

                  {/* 2. 選擇聯絡⼈清單 */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 14,
                    }}
                  >
                    <label
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <input
                        type="radio"
                        name="recipientMode"
                        checked={recipientMode === 'contacts'}
                        onChange={() => handleRecipientModeChange('contacts')}
                        style={{ marginRight: 8 }}
                      />
                      選擇已建立聯絡人
                    </label>
                    {recipientMode === 'contacts' && (
                      <button
                        type="button"
                        onClick={openContactsModal}
                        style={{
                          marginLeft: 12,
                          padding: '6px 14px',
                          borderRadius: 6,
                          border: '1px solid #ddd',
                          background: '#fff',
                          cursor: 'pointer',
                        }}
                      >
                        搜尋
                      </button>
                    )}
                    <span style={{ marginLeft: 12, color: '#6c757d' }}>
                      {recipientMode === 'contacts' &&
                      selectedGroups.length > 0 ? (
                        <div>
                          <div>
                            已選擇：
                            {selectedGroups.length > 0 && (
                              <>
                                {memberGroups
                                  .filter((group) =>
                                    selectedGroups.includes(
                                      group.member_group_id
                                    )
                                  )
                                  .map((group) => group.name)
                                  .join('、')}
                              </>
                            )}
                          </div>
                        </div>
                      ) : (
                        '尚未選擇'
                      )}
                    </span>
                  </div>

                  {/* 3. 上傳手機號碼（CSV） */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 14,
                    }}
                  >
                    <label
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <input
                        type="radio"
                        name="recipientMode"
                        checked={recipientMode === 'csv'}
                        onChange={() => handleRecipientModeChange('csv')}
                        style={{ marginRight: 8 }}
                      />
                      上傳手機號碼（請使用 csv）
                    </label>

                    {/* 匯入檔案按鈕 + 隱藏的 input[type=file] */}
                    {recipientMode === 'csv' && (
                      <label
                        style={{
                          marginLeft: 12,
                          padding: '6px 14px',
                          borderRadius: 6,
                          border: '1px solid #ddd',
                          background: '#fff',
                          cursor: 'pointer',
                        }}
                      >
                        匯入檔案
                        <input
                          type="file"
                          accept=".csv"
                          onChange={handleCsvUpload}
                          style={{ display: 'none' }}
                        />
                      </label>
                    )}

                    {/* 簡單上傳結果摘要 */}
                    <span style={{ marginLeft: 12, color: '#6c757d' }}>
                      {csvName
                        ? `已上傳：${csvName}（${csvPhones.length} 筆）`
                        : '尚未上傳'}
                    </span>
                  </div>

                  {/* 4. 手動輸入（逗號分隔） */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      marginBottom: 6,
                    }}
                  >
                    <label
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        marginTop: 6,
                      }}
                    >
                      <input
                        type="radio"
                        name="recipientMode"
                        checked={recipientMode === 'manual'}
                        onChange={() => handleRecipientModeChange('manual')}
                        style={{ marginRight: 8 }}
                      />
                      手動輸入
                    </label>
                    <textarea
                      placeholder="請輸入使用者的手機號碼（例：0900000000），若要輸入多組請以逗號(,)做為區隔"
                      rows={4}
                      value={manualPhones}
                      onChange={(e) => setManualPhones(e.target.value)}
                      style={{
                        flex: 1,
                        marginLeft: 12,
                        width: '100%',
                        padding: 10,
                        borderRadius: 6,
                        border: errors.manualPhones
                          ? '2px solid #dc3545'
                          : '1px solid #ddd',
                        fontSize: 14,
                        resize: 'vertical',
                      }}
                    />
                  </div>
                  {errors.recipientMode && (
                    <div
                      style={{ color: '#dc3545', fontSize: 12, marginTop: 4 }}
                    >
                      {errors.recipientMode}
                    </div>
                  )}
                  {errors.manualPhones && (
                    <div
                      style={{ color: '#dc3545', fontSize: 12, marginTop: 4 }}
                    >
                      {errors.manualPhones}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* 提交按鈕 */}
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              gap: 12,
              justifyContent: 'center',
            }}
          >
            {/* 取消按鈕 */}
            <button
              type="button"
              onClick={() => {
                if (editMode && onCancel) {
                  onCancel()
                } else {
                  resetForm()
                }
              }}
              style={{
                minWidth: '140px',
                padding: '12px 20px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#5a6269')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#6c757d')}
            >
              取消
            </button>

            {/* 儲存按鈕 - 只有編輯模式且原本是暫存狀態才顯示 */}
            {editMode && (
              <button
                type="button"
                onClick={handleSave}
                disabled={isSubmitting}
                style={{
                  minWidth: '140px',
                  padding: '12px 20px',
                  backgroundColor: '#fff',
                  color: '#67c7aa',
                  borderColor: '#67c7aa',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '500',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'opacity 0.2s',
                  opacity: isSubmitting ? 0.7 : 1,
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = '#e8e8e8')
                }
                onMouseLeave={(e) => (e.target.style.backgroundColor = '#fff')}
              >
                儲存
              </button>
            )}

            {/* 暫存按鈕 - 只有新增模式才顯示 */}
            {!editMode && (
              <button
                type="button"
                onClick={handleSaveDraft}
                disabled={isSubmitting}
                style={{
                  minWidth: '140px',
                  padding: '12px 20px',
                  backgroundColor: '#fff',
                  color: '#67c7aa',
                  borderColor: '#67c7aa',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '500',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'opacity 0.2s',
                  opacity: isSubmitting ? 0.7 : 1,
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = '#e8e8e8')
                }
                onMouseLeave={(e) => (e.target.style.backgroundColor = '#fff')}
              >
                暫存
              </button>
            )}

            {(!editMode || (editMode && taskData?.status === 'draft')) && (
              <button
                type="button"
                onClick={handleShowConfirm}
                disabled={isSubmitting}
                style={{
                  minWidth: '180px',
                  padding: '12px 24px',
                  backgroundColor: isSubmitting ? '#6c757d' : '#67c7aa',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '500',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'background-color 0.2s',
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = '#49a489')
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = '#67c7aa')
                }
              >
                {isSubmitting ? (
                  <>
                    <span
                      style={{
                        display: 'inline-block',
                        width: '16px',
                        height: '16px',
                        border: '2px solid #ffffff40',
                        borderTop: '2px solid #ffffff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        marginRight: '8px',
                      }}
                    />
                    建立中...
                  </>
                ) : (
                  '建立推送任務'
                )}
              </button>
            )}
          </div>
        </div>
      </div>

      {/* 確認資訊 Modal */}
      {showConfirmModal && <ConfirmModal />}

      {/* 成功 Modal */}
      {showSuccessModal && <SuccessModal />}

      {/* 聯絡人選擇 Modal */}
      {showContactsModal && (
        <ContactsModal
          showContactsModal={showContactsModal}
          setShowContactsModal={setShowContactsModal}
          activeTab={activeTab}
          handleTabSwitch={handleTabSwitch}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          memberGroups={memberGroups}
          tags={tags}
          isLoadingGroups={isLoadingGroups}
          isLoadingTags={isLoadingTags}
          selectedGroups={selectedGroups}
          setSelectedGroups={setSelectedGroups}
          selectedTags={selectedTags}
          setSelectedTags={setSelectedTags}
        />
      )}

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  )
}

export default PushTask
